import moment from "moment-timezone"

export const displayDateTime = (dateTime) => {  
  const moment = require('moment')  
  var UTC = moment.tz(dateTime, 'Europe/London')

  var dateTimeUTC = UTC.utc()
  var result = (dateTimeUTC.format('D MMM YYYY')).replace(' ', '\u00A0') +
    '\u00A0 |\u00A0\u00A0' + dateTimeUTC.format('HH:mm') + '\u00A0GMT'

  return result
}

export const displayDate = (dateTime) => {
  const moment = require('moment')  
  var UTC = moment.tz(dateTime, 'Europe/London')

  var dateTimeUTC = UTC.utc()
  var result = (dateTimeUTC.format('D MMM YYYY')).replace(' ', '\u00A0') 

  return result
}

export const displayDateWithFormat = (dateTime) => {
  const moment = require('moment') 
  var result = moment(dateTime).format('D MMM YYYY')

  return result
}

export const GetDateForApiWithFormat = (dateTime) => {
  const moment = require('moment') 
  var result = moment(dateTime).format('yyyyMMDD')

  return result
}

export const currentUtcDateTime = () => {
  const moment = require('moment')  
  return moment.utc().format()
}
